export { default } from './ConfirmationPageButtons';
